import { respondTo } from "@/respondTo";
import { Box, styled as MUIStyled } from "@mui/material";
import Styled from "styled-components";

export const CellectBlogIntroContainer = MUIStyled(Box)(({ theme }) => ({
  position: "relative",
  display: "flex",
  width: "100%",
  flexDirection: "column",
  justifyContent: "flex-end",
  // backgroundImage: "url(/assets/blog/bgImageMobile.webp)",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "60% 0%",
  minHeight: 680,
  padding: "2rem 1rem",

  [theme.breakpoints.up("sm")]: {
    padding: "2rem",
  },
}));

export const CellectBlogIntroCard = MUIStyled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  borderRadius: "24px",
  border: "1px solid rgba(82, 212, 204, 0.50)",
  background: "rgba(3, 31, 50, 0.40)",
  backdropFilter: "blur(13.5px)",
  padding: "1.5rem",
}));

export const CellectBlogColumn = Styled(Box)`      
    display: flex;
    padding: 2.5rem 0rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 1.25rem;
    align-self: stretch;
    
    
    ${respondTo.tablet_portrait`        
        padding: 1.25rem 1.25rem 1.25rem 0rem;      
        gap: 2.5rem;
        flex: 1 0 0;
        width: 32.9rem; 
        max-width: 32.9rem; 
    `}

    ${respondTo.desktop_xl`
        display: flex;
        gap: 2.5rem; 
    `}
`;
